<template>
  <div class="calender-component" ref="calender">
    <div
      class="day-container"
      :style="size"
      v-for="day in days"
      :class="{ selected: day.selected, none: day.num > 31 }"
      @click="select(day)"
    >
      {{ day.num }}
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../../../../assets/style/theme";

.calender-component {
  width: 100%;
  user-select: none;
  border-top: 1px solid @border-color;

  .day-container {
    display: inline-block;
    border: 1px solid @border-color;
    border-top-width: 0;
    border-left-width: 0;
    position: relative;
    justify-content: center;
    cursor: pointer;
    text-align: center;

    &.none {
      cursor: inherit;
      color: white;
    }

    &:hover {
      opacity: 0.7;
    }

    &:nth-child(7n + 7) {
      border-right-width: 0;
    }

    &.selected {
      background: @theme-color;
      color: white;
    }
  }
}
</style>

<script>
export default {
  name: "ScheduleFormRepeatMonthlyCalendarComponent",
  model: {
    prop: "model",
    event: "updateValue",
  },
  props: {
    model: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      width: 375,
      selectList: this.model,
    };
  },
  watch: {
    selectList(val) {
      this.$emit("updateValue", val);
    },
  },
  computed: {
    /**
     * 单个日期宽高
     */
    size() {
      const size = `${this.width / 7}px`;
      return {
        width: size,
        height: size,
        "line-height": size,
      };
    },
    days() {
      let days = [];
      for (let i = 1; i < 36; i++) {
        days.push({
          num: i,
          selected: this.selectList.findIndex((s) => s === i) !== -1,
        });
      }
      return days;
    },
  },
  methods: {
    select(d) {
      // 日历大于31天不让选
      if (d.num > 31) {
        return;
      }
      // 查看是否已选中
      const selectIndex = this.selectList.findIndex((s) => s === d.num);
      // 说明未选中则进行选中
      if (selectIndex === -1) {
        this.selectList.push(d.num);
      } else {
        // 删除的时候最后一个选中不能删除
        if (this.selectList.length > 1) {
          // 已选中则取消
          this.selectList.splice(selectIndex, 1);
        }
      }
    },
  },
};
</script>
